module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Baptiste_1.aad5189.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Baptiste_1.jpg
// module id = 3QVF
// module chunks = 0